import { Component, Fragment } from 'react';
import cx from 'classnames';
import Tabs from '../ui/tabs';
import MonthlyStatement from '../dashboard/monthlyStatement';
import styles from '../../styles/common/containerLayout.scss';
import {
  NAV_LINKS,
  MOBILE_NAV_LINKS,
  KYC_LINK,
  VERIFY_MANDATE_LINK,
  LIST_MANDATE_LINK,
  PROFILE_LINK,
  CREATE_MANDATE,
  PENNY_DROP_LINK,
} from '../../constants/sidenav';
import { Router } from '../../configs/routes';
import Sticky from '../ui/sticky';

interface NavLinks {
  label?: string;
  key?: string;
  link?: boolean;
  href?: string;
  subLinksLoading?: boolean;
  subLinks?: NavLinks[];
}

interface State {
  hasUserInvested: boolean;
  navLinks: NavLinks[];
  mobileNavLinks: NavLinks[];
}

class ContainerLayout extends Component<any, State> {
  constructor(props: any) {
    super(props);
    this.state = {
      hasUserInvested: props.hasUserInvested,
      navLinks: NAV_LINKS,
      mobileNavLinks: MOBILE_NAV_LINKS,
    };
  }

  public UNSAFE_componentWillReceiveProps(nextProps: any) {
    const {
      pendingActions,
      hasUserInvested,
      mandateList,
      hasSidebar,
      fetchingPendingActions,
      mandateData,
    } = nextProps;
    const { navLinks } = this.state;
    if (hasSidebar) {
      // const isMandatePending =
      //   pendingActions.includes('MANDATE') ||
      //   pendingActions.includes('MANDATE_DIRECT');

      // Check mandate for direct only.
      const isMandatePending =
        pendingActions && pendingActions.includes('MANDATE_DIRECT');
      let hasMandates;
      if (mandateList) {
        hasMandates =
          (
            mandateList.filter(
              (mandate) =>
                mandate.mandateStatus !== 'INITIATED' &&
                mandate.mandateStatus !== 'REJECTED'
            ) || []
          ).length > 0;
      }
      const navs = navLinks.map((link) => {
        const subLinks = [];
        if (link.key === '/dashboard' && hasUserInvested) {
          link.subLinks = [];
          if (pendingActions.length) {
            if (
              isMandatePending &&
              mandateData &&
              !mandateData.userOptedForMonthlyLinks
            ) {
              subLinks.push(VERIFY_MANDATE_LINK);
            }
            if (pendingActions.includes('KYC')) {
              subLinks.push(KYC_LINK);
            }
            if (pendingActions.includes('PENNY_DROP_PENDING')) {
              subLinks.push(PENNY_DROP_LINK);
            }
            link.subLinks = subLinks;
            link.subLinksLoading = false;
          } else {
            link.subLinksLoading = fetchingPendingActions;
          }

          // if (!fetchingPendingActions && !isMandatePending && hasMandates) {
          //   link.subLinks.push(LIST_MANDATE_LINK);
          // }

          if (!fetchingPendingActions && hasMandates) {
            link.subLinks.push(LIST_MANDATE_LINK);
          }

          if (
            mandateData &&
            mandateData.userOptedForMonthlyLinks &&
            !hasMandates
          ) {
            link.subLinks.push(CREATE_MANDATE);
          }
        }

        return link;
      });

      const mobileNav = [MOBILE_NAV_LINKS[0]];
      if (pendingActions && pendingActions.length) {
        if (isMandatePending) {
          mobileNav.push(VERIFY_MANDATE_LINK);
        }

        if (pendingActions.includes('KYC')) {
          mobileNav.push(KYC_LINK);
        }
      } else if (!fetchingPendingActions) {
        if (hasMandates) {
          // !isMandatePending && hasMandates
          mobileNav.push(LIST_MANDATE_LINK);
        }
        mobileNav.push(PROFILE_LINK);
      } else {
        mobileNav.push({ loading: true });
        mobileNav.push({ loading: true });
      }

      this.setState({
        navLinks: navs,
        mobileNavLinks: mobileNav.slice(0, 3),
      });
    }
  }

  public switchTabs = (e: any) => {
    const url = e.currentTarget.dataset.href;
    if (url) {
      Router.pushRoute(`${url}`, {
        shallow: true,
      });
    }
  };

  public render() {
    const {
      hasSidebar,
      path,
      hideHeader,
      hasUserInvested,
      showMobileHeader,
      userInfo,
      showNudge,
      isMobile,
      nudgeRequired,
      downloadElssProof,
      elssInvestmentYears,
    } = this.props;
    const { mobileNavLinks, navLinks } = this.state;
    return (
      <div
        className={cx(styles['main-wrapper'], {
          row: hasSidebar,
          [styles['mt0']]: hideHeader,
          [styles['background-grey']]: showMobileHeader,
          [styles['mt120']]: showNudge && isMobile && nudgeRequired,
        })}
      >
        {/* {showDeadline && (
          <div
            style={{
              backgroundColor: '#1678FB',
              padding: '12px 48px',
              fontSize: '16px',
              lineHeight: '24px',
              position: 'relative',
              color: 'white',
              display: 'flex',
            }}
          >
            <img
              style={{ cursor: 'pointer', height: '24px' }}
              src="/save/static/timer.png"
              width={24}
              height={24}
            />
            <div className="lil-ml-4">
              <span style={{ fontWeight: '700' }} className="lil-mr-2">
                Deadline for tax investments for FY 2022-2023 is 29th March
                2023.
              </span>
              <span>* KYC should be verified before the deadline.</span>
            </div>

            <span
              onClick={() => {
                this.setState({
                  showDeadline: false,
                });
              }}
              className="close-icon"
            />
          </div>
        )} */}
        {hasSidebar ? (
          <Fragment>
            <div
              className={cx(
                'columns large-3 medium-2 desktop-only',
                styles['left-content']
              )}
            >
              <div className={styles['left-navbar']}>
                <Sticky
                  marginLeftRequired={true}
                  noWidth={true}
                  hideShadow={true}
                  noPadding={true}
                  hideAfter="sticky-end"
                  hideAfterOffset={600}
                  zIndex={9}
                >
                  <Tabs
                    selected={path}
                    showSublinks={hasUserInvested}
                    align="vertical"
                    items={navLinks}
                    showIcons={true}
                  />
                  <MonthlyStatement
                    userInfo={userInfo}
                    downloadElssProof={downloadElssProof}
                    elssInvestmentYears={elssInvestmentYears}
                  />
                </Sticky>
              </div>
            </div>

            <div
              className={cx(
                'small-12 columns p0 mobile-only--display',
                styles['post-inv-nav-mobile']
              )}
            >
              <Tabs
                selected={path}
                showSublinks={hasUserInvested}
                align="horizontal"
                items={mobileNavLinks}
                showIcons={true}
                switchTabs={this.switchTabs}
              />
            </div>
          </Fragment>
        ) : null}
        <div
          className={cx('sticky-end-block', {
            'columns large-9 medium-10': hasSidebar,
            [styles['right-content']]: hasSidebar,
          })}
        >
          {this.props.children}
        </div>
      </div>
    );
  }
}

export default ContainerLayout;



// WEBPACK FOOTER //
// ./components/common/containerLayout.tsx